import React, { useEffect } from 'react';
import './Dialog.css';

export interface DialogProps {
  open: boolean;
  children: React.ReactNode;
  onClose?: () => void;
  closeOnBackdrop?: boolean;
  closeOnEscape?: boolean;
  width?: 'sm' | 'md' | 'lg' | 'xl';
}

const widthClass = {
  sm: 'dialog-sm',
  md: 'dialog-md',
  lg: 'dialog-lg',
  xl: 'dialog-xl',
};

export function Dialog({
  open,
  children,
  onClose,
  closeOnBackdrop = true,
  closeOnEscape = true,
  width = 'md',
}: DialogProps) {
  useEffect(() => {
    if (!closeOnEscape || !open) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () =>
      window.removeEventListener(
        'keydown',
        handleKeyDown
      );
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="dialog-backdrop"
      onClick={() =>
        closeOnBackdrop && onClose?.()
      }
    >
      <div
        className={`dialog ${widthClass[width]}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}